import classNames from 'classnames';
import { formatTokenAmountCompact } from 'utils/FormatNumber';
import Tooltip from 'modules/shared-components/tooltip';

interface Props {
  data: {
    title: string;
    value: number;
    suffix?: string | null;
    tooltip: string;
  };
  index: number;
}

const MainListComponent = ({ data, index }: Props) => {
  return (
    <div
      className={classNames(
        'bg-white-300 dark:bg-black-700 xxs:py-6 xxs:px-4 w-1/2 lg:w-1/3 rounded-md',
        index === 2
          ? 'hidden lg:flex justify-center items-center'
          : 'flex justify-center items-center'
      )}
    >
      <div className="space-y-1 text-center ">
        <div className="text-sm font-regular">
          {data.title}{' '}
          <Tooltip text={data.tooltip}>
            <span className="d-inline-block">
              <i className="mdi mdi-information-outline" />
            </span>
          </Tooltip>
        </div>
        <div
          className={classNames(
            'text-xl font-medium',
            data.suffix === '%' &&
              (data.value < 0 ? 'text-red-warning' : 'text-green-success')
          )}
        >
          {data.suffix === '%' && data.value > 0 && '+'}
          {formatTokenAmountCompact(data.value)}
          {data.suffix}
        </div>
      </div>
    </div>
  );
};

export default MainListComponent;
